if (!customElements.get('engraving-symbols')) {
  customElements.define('engraving-symbols',
    class EngravingSymbols extends HTMLElement {
      constructor() {
        super();         
      }
    
      connectedCallback() {
        var container = this.closest('.fieldset');
        
        this.elements = {
          input: container.querySelector('input[type="text"]'),
          triggerButton: this.previousSibling,
          symbolsWrapper: this.querySelector('.engraving-symbols'),
          symbols: this.querySelectorAll('.engraving-symbol')
        };
    
        this.setupEventListeners();
      }
    
      // Creates the event listeners
      setupEventListeners() {
        if (this.elements.triggerButton !== null) this.elements.triggerButton.addEventListener('click', this.onTriggerButtonClick.bind(this));
        if (this.elements.symbols.length > 0) {
          this.elements.symbols.forEach((symbol) => {
            symbol.addEventListener('click', this.onSymbolClick.bind(this));
          });            
        } 
      }
    
      // On clicking on the trigger button
      onTriggerButtonClick(event) {   
        event.stopImmediatePropagation();
        this.elements.symbolsWrapper.classList.toggle('hidden');
      } 
    
      // On clicking on a symbol
      onSymbolClick(event) {        
        event.stopImmediatePropagation();

        var input = this.elements.input,
            symbol = event.currentTarget.textContent,
            maxAttr = parseInt(input.getAttribute('maxlength'), 10),
            hasMax = !isNaN(maxAttr) && maxAttr > 0;

        // Construit la nouvelle valeur en comptant chaque emoji/symbole comme 1 caractere
        var chars = Array.from(input.value + symbol);
        if (hasMax && chars.length > maxAttr) {
          chars = chars.slice(0, maxAttr);
        }
        input.value = chars.join('');

        // Declenche un vrai 'input' event pour que le filtre + le decompte s'appliquent
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      }       
    }
  );
}